module.exports = __webpack_public_path__ + "static/media/endCall.ad1a7b53.svg";